import { Injectable } from '@angular/core';
import { RequestService } from '@core/services/request/request.service';
import { RequestResponse } from '@core/services/request/model/request.model';
import { MapCoordsApi } from '@core/api/model/consumption/map-coords-api.model';
import { ApiDirectory } from '@core/api/api-directory';
import { Observable } from 'rxjs';
import { PortugalMapTopology, SpainMapTopology } from '@core/api/model/consumption/map-topology.model';
import { HttpParamsService } from '@core/services/http-params/http-params.service';
import { LoadingIds } from '@shared/constants/loading';
import { MasterInstallationModel } from '@core/domain/model/master/master-installation.model';

@Injectable({
  providedIn: 'root',
})
export class ApiMapService {
  constructor(
    private readonly _request: RequestService,
    private readonly _params: HttpParamsService
  ) {}

  public fetchInstallationCoords(installations: MasterInstallationModel[]): Observable<RequestResponse<Array<MapCoordsApi>>> {
    return this._request.post(
      ApiDirectory.Consumo.Geolocalizacion({}),
      { listaCups: installations.map((value) => ({ codigoPostal: value.postalCode, cups: value.cups })) },
      {
        loading: LoadingIds.FETCH_MAP_COORDS,
      }
    );
  }

  public fetchSpainTopology(): Observable<SpainMapTopology> {
    return this._request.getAsset('map/spain.json', {
      loading: LoadingIds.FETCH_MAP_GEOMETRY,
    });
  }

  public fetchPortugalTopology(): Observable<PortugalMapTopology> {
    return this._request.getAsset('map/portugal.json', {
      loading: LoadingIds.FETCH_MAP_GEOMETRY,
    });
  }
}
